<!-- Brand -->
<div class="sidenav-brand">
  <span class="brand-name">WC 2026</span>
  <span class="version-label">v{{ version }}</span>
</div>

<!-- User profile -->
<div class="sidenav-profile" (click)="goToPage('/profile')">
  <div class="avatar-wrapper">
    <app-avatar [user]="user"></app-avatar>
  </div>
  <div class="profile-info">
    <span class="profile-name">{{ user?.name }}</span>
    <span class="profile-hint">Toca para editar perfil</span>
  </div>
</div>

<!-- Main nav -->
<nav class="sidenav-nav">
  <span class="nav-label">Menú</span>

  <button mat-button class="menu-button" (click)="goToPage('/home')">
    <mat-icon>home</mat-icon>
    <span>Inicio</span>
  </button>

  <button mat-button class="menu-button" (click)="goToPage('/standings')">
    <mat-icon>format_list_numbered</mat-icon>
    <span>Clasificación</span>
  </button>

  <button mat-button class="menu-button" (click)="goToPage('/poll')">
    <mat-icon>poll</mat-icon>
    <span>Pronósticos</span>
  </button>

  <button mat-button class="menu-button" (click)="goToPage('/stats')">
    <mat-icon>query_stats</mat-icon>
    <span>Estadísticas</span>
  </button>

  @if (isAdmin) {
    <span class="nav-label">Admin</span>
    <button mat-button class="menu-button" (click)="goToPage('/admin')">
      <mat-icon>admin_panel_settings</mat-icon>
      <span>Administración</span>
    </button>
  }
</nav>

<!-- Footer nav -->
<div class="sidenav-footer">
  <button mat-button class="menu-button" (click)="goToPage('/rules')">
    <mat-icon>help_outline</mat-icon>
    <span>Reglas</span>
  </button>

  <button mat-button class="menu-button danger" (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Salir</span>
  </button>
</div>
